import React, { Fragment } from 'react';
import { format } from 'date-fns';
import { capitalizeFirstLetter, Log } from '../../core';

interface ILogItemProps {
  log: Log;
  customerId?: string;
}

const LogItem: React.FunctionComponent<ILogItemProps> = (props) => {
  const log = props.log;

  const [logModal, setLogModal] = React.useState<{
    isOpen?: boolean;
    logId?: string;
  }>({});
  const [isValid, setIsValid] = React.useState(true);
  const toggleLog = (id?: string) => {
    let isOpen = !logModal.isOpen;
    if (id !== logModal.logId) {
      isOpen = true;
    }
    setLogModal({ isOpen, logId: id });
  };

  // const printValues = (obj: any) => {
  //   for (const key in obj) {
  //     if (isValidKey(key)) {
  //       if (typeof obj[key] === 'object') {
  //         printValues(obj[key]);
  //       } else {
  //         if (
  //           isValidKey(key) &&
  //           obj[key] !== true &&
  //           obj[key] !== false &&
  //           obj[key] !== '~'
  //         ) {
  //           setIsValid(true);
  //         }
  //       }
  //     }
  //   }
  // };

  // React.useEffect(() => {
  //   printValues(log.data);
  // }, [log.data]);

  const isValidKey = (key: string) => {
    if (
      key === 'updatedAt' ||
      key === 'createdAt' ||
      key === '_id' ||
      key === 'previousCRMAgent' ||
      key === 'avatar' ||
      key === 'oslInfo' ||
      key === 'primaryVehicleModel__added' ||
      key === 'primaryVehicleVariant__added' ||
      key === 'combination' ||
      key === 'createdBy' ||
      key === 'leadId' ||
      key === 'actionCode' ||
      key === 'actionId' ||
      key === 'status' ||
      key === 'fieldname' ||
      key === 'encoding' ||
      key === 'mimetype' ||
      key === 'bucket' ||
      key === 'key' ||
      key === 'acl' ||
      key === 'contentType' ||
      key === 'storageClass' ||
      key === 'location' ||
      key === 'etag' ||
      key === 'buyingInfluenceId' ||
      key === 'userId' ||
      key === 'size' ||
      key === '__v' ||
      key === 'createdByClient'
    ) {
      return false;
    }
    return true;
  };

  const getLogDetails = (key: string, value: any) => {
    if (!value) {
      return <></>;
    }

    if (!isValidKey(key)) {
      return <></>;
    }

    if (
      (typeof value === 'string' || typeof value === 'number') &&
      key.includes('__added')
    ) {
      return (
        <div className="p-1">
          <span className="text-gray-500 mr-1 11">
            {capitalizeFirstLetter(
              key
                .replace('__added', '')
                .replace(/([A-Z])/g, ' $1')
                .trim()
            )}
            {'  '}: None
          </span>
          <i className="icon-arrow-right icon-flip-rtl mx-2 font-xxs"></i>{' '}
          {value}
        </div>
      );
    }

    if (typeof value === 'boolean' && key.includes('__added')) {
      return (
        <div className="p-1">
          <span className="text-gray-500 mr-1 11">
            {capitalizeFirstLetter(
              key
                .replace('__added', '')
                .replace(/([A-Z])/g, ' $1')
                .trim()
            )}
            {'  '}: None
          </span>
          <i className="icon-arrow-right icon-flip-rtl mx-2 font-xxs"></i>{' '}
          {value === true ? 'Yes' : 'No'}
        </div>
      );
    }

    if (typeof value === 'string' && !key.includes('__added')) {
      return (
        <div className="">
          <span className="text-gray-500 mr-1 12">
            {capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1').trim())} :{' '}
          </span>
          {value}
        </div>
      );
    }

    if (typeof value === 'object' && key.includes('__added') && value.name) {
      return (
        <div className="p-1">
          <span className="text-gray-500 mr-1 13">
            {capitalizeFirstLetter(
              key
                .replace('__added', '')
                .replace(/([A-Z])/g, ' $1')
                .trim()
            )}{' '}
            : None
          </span>
          <i className="icon-arrow-right icon-flip-rtl mx-2 font-xxs"></i>{' '}
          {value.name}
        </div>
      );
    }

    if (
      typeof value === 'object' &&
      (typeof value?.__old === 'string' ||
        typeof value?.__old === 'boolean' ||
        typeof value?.__old === 'number') &&
      (typeof value?.__new === 'string' ||
        typeof value?.__new === 'boolean' ||
        typeof value?.__new === 'number')
    ) {
      return (
        <div className="p-1">
          <span className="text-gray-500 mr-1 14">
            {capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1').trim())} :
          </span>
          {typeof value?.__old === 'boolean'
            ? value.__old === true
              ? 'Yes'
              : 'No'
            : value.__old}{' '}
          <i className="icon-arrow-right icon-flip-rtl mx-2 font-xxs"></i>{' '}
          {typeof value?.__new === 'boolean'
            ? value.__new === true
              ? 'Yes'
              : 'No'
            : value.__new}
        </div>
      );
    }

    if (
      typeof value === 'object' &&
      value?.__new &&
      typeof value?.__new === 'string'
    ) {
      return (
        <div className="p-1">
          <span className="text-gray-500 mr-1 15">
            {capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1').trim())} :{' '}
          </span>
          {value.__new}
        </div>
      );
    }

    if (
      typeof value === 'object' &&
      value?.__new &&
      typeof value?.__new === 'object'
    ) {
      return (
        <>
          {Object.keys(value.__new).map((childKey) => {
            return typeof value.__new[childKey] === 'string' ? (
              <div className="p-1">
                {getLogDetails(childKey, value.__new[childKey])}
              </div>
            ) : (
              <></>
            );
          })}
        </>
      );
    }

    if (
      typeof value === 'object' &&
      value?.__old &&
      typeof value?.__old === 'string'
    ) {
      return (
        <div className="p-1">
          <span className="text-gray-500 mr-1 16">
            {capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1').trim())} :
          </span>
          {value.__old}
        </div>
      );
    }

    if (
      typeof value === 'object' &&
      !Array.isArray(value) &&
      value.name &&
      value.name.__old &&
      value.name.__new
    ) {
      return (
        <div className="p-1">
          <span className="text-gray-500 mr-1 17">
            {capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1').trim())} :
          </span>
          {value.name.__old}{' '}
          <i className="icon-arrow-right icon-flip-rtl mx-2 font-xxs"></i>{' '}
          {value.name.__new}
        </div>
      );
    }

    if (typeof value === 'object' && Array.isArray(value)) {
      return value[0] === '-' || value[0] === '+' || value[0] === ' ' ? (
        <>
          {typeof value[1] === 'string' || typeof value[1] === 'number' ? (
            <>
              {value[0] !== ' ' && (
                <div className="p-1">
                  <span className="text-gray-500 mr-1 text-primary">
                    {value[0] === '-' ? 'Removed' : 'Added'}
                  </span>{' '}
                  {value[1]}
                </div>
              )}
            </>
          ) : (
            <>
              {value[1] !== undefined && (
                <div className="pl-1 pt-3">
                  <span className="text-gray-500 mr-1 18 text-primary ">
                    {value[0] === '-' ? 'Removed' : 'Added'}
                  </span>
                  <div className="col-auto pl-0 pt-3">
                    {Object.keys(value[1]).map((ky) => {
                      return <>{childLog(value[1][ky], ky)}</>;
                    })}
                  </div>
                </div>
              )}
            </>
          )}
        </>
      ) : (
        <>
          {value[0] === '~' ? (
            <>
              {value[1] !== undefined && (
                <>
                  {Object.keys(value[1]).map((ky) => {
                    return <>{childLog(value[1][ky], ky)}</>;
                  })}
                </>
              )}
            </>
          ) : (
            <>
              {value.map((item) => {
                return getArrayDetails(item, key);
              })}
            </>
          )}
        </>
      );
    }

    if (typeof value === 'object' && !Array.isArray(value)) {
      return (
        <div className="p-1">
          {Object.keys(value).map((ky) => {
            return childLog(value[ky], ky, !!(ky === '__old'));
          })}
        </div>
      );
    }
  };

  const getArrayDetails = (value: any, key: string) => {
    if (!isValidKey(key)) {
      return <></>;
    }

    if (
      typeof value === 'object' &&
      Array.isArray(value) &&
      (value[0] === '-' || value[0] === '+') &&
      (typeof value[1] === 'string' || typeof value[1] === 'number')
    ) {
      return (
        <div className="p-1">
          <span className="text-gray-500 mr-1 19">
            {value[0] === '-' ? 'Removed' : 'Added'}
          </span>{' '}
          {value[1]}
        </div>
      );
    }

    if (
      typeof value === 'object' &&
      Array.isArray(value) &&
      (value[0] === '-' || value[0] === '+') &&
      typeof value[1] === 'object'
    ) {
      return (
        <div className="p-1 m-0">
          <span className="text-gray-500 mr- 110 text-primary">
            {value[0] === '-' ? 'Removed' : 'Added'}
          </span>{' '}
          <div className="col-auto pl-0 ml-0 pt-3">
            {Object.keys(value[1]).map((ky) => {
              return <>{childLog(value[1][ky], ky)}</>;
            })}
          </div>
        </div>
      );
    }

    if (
      typeof value === 'object' &&
      Array.isArray(value) &&
      value[0] === '~' &&
      typeof value[1] === 'object'
    ) {
      return (
        <div className="row m-0 pl-1">
          <span className="text-gray-500 mr-1 111">
            {capitalizeFirstLetter(
              key
                .replace('__added', '')
                .replace(/([A-Z])/g, ' $1')
                .trim()
            )}
          </span>{' '}
          <div className="col-auto pl-0">
            {Object.keys(value[1]).map((ky) => {
              return <>{childLog(value[1][ky], ky)}</>;
            })}
          </div>
        </div>
      );
    }

    if (typeof value === 'object' && !Array.isArray(value)) {
      return (
        <div className="p-1 row m-0">
          <div className="col-auto pl-0">
            {Object.keys(value).map((ky) => {
              return <>{childLog(value[ky], ky)}</>;
            })}
          </div>
        </div>
      );
    }

    if (typeof value === 'object') {
      return (
        <div className="p-1">
          {Object.keys(value).map((ky) => {
            return <>{childLog(value[ky], ky)}</>;
          })}
        </div>
      );
    }
  };

  function childLog(value: any, key: string, showNone?: boolean) {
    if (!isValidKey(key)) {
      return <></>;
    }

    if (
      (typeof value === 'string' || typeof value === 'number') &&
      key.includes('__added')
    ) {
      return (
        <p className="pl-1">
          <span className="text-gray-500 mr-1 11">
            {capitalizeFirstLetter(
              key
                .replace('__added', '')
                .replace(/([A-Z])/g, ' $1')
                .trim()
            )}
            {'  '}: None
          </span>
          <i className="icon-arrow-right icon-flip-rtl mx-2 font-xxs"></i>{' '}
          {value}
        </p>
      );
    }

    if (typeof value === 'string') {
      return value?.trim() !== '' && value !== '~' ? (
        <p className="">
          <span className="mr-1 text-gray-500 11">
            {capitalizeFirstLetter(
              key
                ?.replace('__added', '')
                .replace(/([A-Z])/g, ' $1')
                .trim()
            )}{' '}
            :
          </span>
          {capitalizeFirstLetter(value?.replace(/([A-Z])/g, ' $1').trim())}
          {showNone && (
            <>
              {' '}
              : <i className="icon-arrow-right icon-flip-rtl mx-2 font-xxs"></i>
              None
            </>
          )}
        </p>
      ) : (
        <></>
      );
    }
    if (typeof value === 'number') {
      return (
        <p className="">
          <span className="mr-1 text-gray-500 111">
            {capitalizeFirstLetter(
              key
                ?.replace('__added', '')
                .replace(/([A-Z])/g, ' $1')
                .trim()
            )}{' '}
            :
          </span>
          {value}
          {showNone && (
            <>
              <i className="icon-arrow-right icon-flip-rtl mx-2 font-xxs"></i>
              None
            </>
          )}
        </p>
      );
    }

    if (
      typeof value === 'object' &&
      (typeof value?.__old === 'string' || typeof value?.__old === 'number') &&
      (typeof value?.__new === 'string' || typeof value?.__new === 'number')
    ) {
      return (
        <div className="pb-2 pl-1">
          <span className="text-gray-500 mr-1 112">
            {capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1').trim())} :
          </span>
          {value.__old}
          <i className="icon-arrow-right icon-flip-rtl mx-2 font-xxs"></i>{' '}
          {value.__new}
        </div>
      );
    }

    if (
      typeof value === 'object' &&
      typeof value?.__old === 'boolean' &&
      typeof value?.__new === 'boolean'
    ) {
      return (
        <div className="pb-2">
          <span className="text-gray-500 mr-1 113">
            {capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1').trim())} :
          </span>
          {value.__old === true ? 'Yes' : 'No'}
          <i className="icon-arrow-right icon-flip-rtl mx-2 font-xxs"></i>{' '}
          {value.__new === true ? 'Yes' : 'No'}
        </div>
      );
    }

    if (value && typeof value === 'object' && !Array.isArray(value)) {
      return (
        <div className="pb-1 pt-1 row m-0 11">
          {key !== '1' && key !== '__old' && (
            <span className="mr-1 text-gray-500 1111 ">
              {capitalizeFirstLetter(
                key
                  ?.replace('__added', '')
                  ?.replace(/([A-Z])/g, ' $1')
                  .trim()
              )}{' '}
            </span>
          )}

          <div
            className={`col-12 pt-2 mt-1 ${
              key !== '1' && key !== '__old' ? '' : 'pl-0'
            }`}
          >
            {Object.keys(value).map((ky) => {
              return typeof value[ky] === 'string' && isValidKey(ky) ? (
                <p className="11">
                  <span className="mr-1 text-gray-500 ">
                    {capitalizeFirstLetter(
                      ky
                        ?.replace('__added', '')
                        ?.replace('__deleted', '')
                        ?.replace(/([A-Z])/g, ' $1')
                        .trim()
                    )}{' '}
                  </span>
                  : {value[ky]}
                  {showNone && (
                    <>
                      <i className="icon-arrow-right icon-flip-rtl mx-2 font-xxs"></i>
                      None
                    </>
                  )}
                </p>
              ) : (
                <>{childLog(value[ky], ky, !!(key === '__old'))}</>
              );
            })}
          </div>
        </div>
      );
    }

    // when the field value is an array of strings

    if (
      value &&
      typeof value === 'object' &&
      Array.isArray(value) &&
      value[0] &&
      typeof value[0] === 'string'
    ) {
      if (!value.find((v) => typeof v !== 'string')) {
        let stringValues;
        if (value.length > 25) {
          stringValues = value.slice(0, 25);
          stringValues.push('...');
        } else {
          stringValues = value;
        }
        return stringValues[0]?.trim() !== '' && stringValues[0] !== '~' ? (
          <p className="">
            <span className="mr-1 text-gray-500 11">
              {capitalizeFirstLetter(
                key
                  ?.replace('__added', '')
                  .replace(/([A-Z])/g, ' $1')
                  ?.trim()
              )}{' '}
              :
            </span>
            {stringValues?.map(
              (v) =>
                ` ${capitalizeFirstLetter(
                  v?.replace(/([A-Z])/g, ' $1')?.trim()
                )},`
            )}
            {showNone && (
              <>
                {' '}
                :{' '}
                <i className="icon-arrow-right icon-flip-rtl mx-2 font-xxs"></i>
                None
              </>
            )}
          </p>
        ) : (
          <></>
        );
      }
    }

    return <></>;
  }

  return log?.data && isValid ? (
    <Fragment>
      <li className="d-flex mb-3 position-relative zIndex-1 activity-changelog">
        <div className="activity-icon rounded-circle bg-white d-flex align-items-center justify-content-center mr-2 mt-2 border"></div>
        <div className="bg-white activity-box rounded p-2 col font-xs font-weight-semibold">
          <div
            onClick={() => toggleLog(log?._id)}
            className="align-items-center d-flex p-1 mb-1 cursor-pointer"
          >
            <div className="changelog-header">
              {log.title}
              {props.customerId && log?.meta?.leadTitle && (
                <> - {log?.meta?.leadTitle}</>
              )}
              {log?.meta?.eventTitle && <> - {log?.meta?.eventTitle}</>}
              <span className="text-gray-500 ml-1">-</span>
              <span className="text-gray-500 ml-1">
                {format(new Date(log.createdAt), 'MMMM dd,yyyy, hh:mm a')}
              </span>
              <span className="text-gray-500 ml-1">-</span>
              <span className="text-gray-500 ml-1">
                {log.createdBy?.name ||
                  log.createdByClient?.name ||
                  (log.systemGenerated ? 'System-Automatic' : '')}
              </span>
            </div>
            <div className="icon-box icon-box--xs ml-auto d-inline-flex align-items-center justify-content-center font-xxxxs">
              <i
                className={`${
                  log?.data != null &&
                  logModal.isOpen &&
                  logModal.logId === log?._id
                    ? 'icon-chevron-up'
                    : 'icon-chevron-down'
                }`}
              ></i>
            </div>
          </div>
          {log?.data != null && logModal.isOpen && logModal.logId === log?._id && (
            <>
              {log?.category?.toLowerCase() === 'lead' &&
              log?.eventType === 'create' ? (
                <></>
              ) : (
                <>
                  {Object.keys(log.data).map((key) => {
                    return <>{getLogDetails(key, log.data[key])}</>;
                  })}
                </>
              )}
            </>
          )}
        </div>
      </li>
    </Fragment>
  ) : (
    <></>
  );
};

export default LogItem;
